export enum TravelDetailProvider {
  BOOKING_BUSES = 'BOOKING_BUSES',
  USER_HISTORY = 'USER_HISTORY',
  BUS_RESULTS = 'BUS_RESULTS',
  USER_HISTORY_BUSES = 'USER_HISTORY_BUSES',
  RESUME_WITH_EXTRA = 'RESUME_WITH_EXTRA',
}
